import React, { useEffect, useRef } from 'react';
import styles from './Me.module.css';
import betty from "../../images/בטי קנפו תמונה ראשית.png";

const AboutMe = () => {
  const containerRef = useRef(null);

  const handleButtonClick = () => {
    const phoneNumber = "+972508177277";
    const message = "היי בטי, הגעתי מהדף שלך ואני רוצה לשמוע עוד על...";
    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappURL, "_blank");
  };

  useEffect(() => {
    if (containerRef.current) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.style.opacity = '1';
              entry.target.style.transform = 'translateY(0)';
            }
          });
        },
        { threshold: 0.2 }
      );

      const revealElements = containerRef.current.querySelectorAll(`.${styles.revealItem}`);
      revealElements.forEach((el) => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(20px)';
        el.style.transition = 'opacity 1s ease, transform 1s ease';
        observer.observe(el);
      });

      return () => observer.disconnect();
    }
  }, []);

  return (
    <section ref={containerRef} className={styles.section} id="מי-אני">
      <div className={styles.container}>
        <div className={`${styles.imageWrapper} ${styles.revealItem}`}>
          <img src={betty} alt="בטי קנפו" className={styles.image} />
        </div>

        <div className={`${styles.content} ${styles.revealItem}`}>
          <h2 className={styles.mainTitle}>נעים להכיר, בטי קנפו</h2>

          <div className={styles.textBlock}>
            <p className={styles.paragraph}>
              מאז שאני זוכרת את עצמי, יופי משך אותי. מגיל צעיר הייתי מאפרת חברות, משחקת עם צבעים,
              ומקשיבה לכל אחת שמביטה במראה ורוצה להרגיש קצת יותר שלמה עם עצמה.
              כבר בגיל 15 למדתי איפור, ומאותו רגע ידעתי שתחום היופי זה המקום שלי.
            </p>
            <div className={styles.divider}></div>

            <p className={styles.paragraph}>
              עם הזמן גיליתי שהנשים שמגיעות אליי רוצות להשאר ורוצות יותר מטיפול אחד.
              שבמקום לעבור בין 5 מקומות בחודש יהיה להן את כל הטיפולים במקום אחד!.
              לכן החלטתי לפתוח מקום שבו הכל נמצא – סלון יופי שמכיל עיצוב גבות, איפור קבוע, ריסים, קורסים, ושיזוף.
              מקום אחד שבו את מקבלת את כל מה שאת צריכה כדי להרגיש יפה ובטוחה.
            </p>
            <div className={styles.divider}></div>

            <p className={styles.paragraph}>
              אני מאמינה שכל יהלום צריך ליטוש. כל אישה כבר יפה, אבל טיפול נכון,
              יחס אישי ודיוק בפרטים הקטנים הם מה שמדגיש את הזוהר שבה.
              אני לא רודפת אחרי טרנדים – אני מקשיבה למה שמתאים לך.
              לא כל גבה צריכה להיות זהה, לא כל צבע נכון לכולן .
              <strong>כל טיפול מותאם אישית אלייך</strong>
            </p>
            <div className={styles.divider}></div>

         
            <p className={styles.finalText}>
             אני אוהבת לראות את השינוי –
              כשלקוחה יוצאת מהמכון, מביטה במראה, ומחייכת חיוך אמיתי.
              זה הרגע שבו אני יודעת שעשיתי את הדבר הנכון.
            </p>
          </div>

          <button className={styles.ctaButton} onClick={handleButtonClick}>
            <span className={styles.buttonIcon}>💫</span>
       השינוי שלך מתחיל בלחיצה כאן
          </button>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
